import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from "../model/track-action-result";
import { ContaIonDataParse } from "../conta-ion/util/conta-ion-data-parse";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { BirthCountryInvestAction } from './actions/birth-country-action';

export class BasicPersonalTrack extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('document-type', ['personal-data', 'document-type']),
    new TrackInfo('document-name', ['personal-data', 'document-name']),
    new TrackInfo('document-number', ['personal-data', 'document-number']),
    new TrackInfo('document-issuing', ['personal-data', 'document-issuing']),
    new TrackInfo('expedition-state', ['personal-data', 'expedition-state']),
    new TrackInfo('parentage', ['personal-data', 'parentage']),
    new TrackInfo('birth-country', ['personal-data', 'birth-country'], undefined, {
      undefined,
      actionName: ActionList.ActionStateBR
    }),
    new TrackInfo('birth-state', ['personal-data', 'birth-state']),
    new TrackInfo('birth-city', ['personal-data', 'birth-city']),
    new TrackInfo('nationality', ['personal-data', 'nationality']),
    new TrackInfo('gender', ['personal-data', 'gender']),

  ];

  track = [];

  constructor(private cacheNativeService: CacheService) {
    super();
    this.track = this.originalTracks;
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_PERSONAL;
  }

  async loadData() {
    // MobileMockData.executeMockCall(500);
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    localStorage.setItem('cache-native', JSON.stringify(data));
    return Promise.resolve(data);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    return BirthCountryInvestAction.execute(data);
  }
  
  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionStateBR = 'actionStateBR',
}